// iluminacao.jsx
// Configuração centralizada dos circuitos de iluminação

export const iluminacaoConfig = [
  { id: "grupo01", modulo: "1", idx: "1", descricao: "Poste", lightType: "normal", multipleInstances:[
    { x: 4, y: 91, width: 2.5, height: 5, circleNumber: 1 },
    { x: 7.5, y: 61, width: 2.5, height: 5, circleNumber: 1 },
    { x: 9, y: 47, width: 2.5, height: 5, circleNumber: 1 },
    { x: 11, y: 28, width: 2.5, height: 5, circleNumber: 1 }
  ]},
  { id: "grupo02", modulo: "1", idx: "2", descricao: "Market", x: 43, y: 59, width: 2.5, height: 5, circleNumber: 2, lightType: "normal", },
  { id: "grupo03", modulo: "1", idx: "3", descricao: "Smart Locker Cancela Serviço", x: 27, y: 63, width: 2.5, height: 5, circleNumber: 3, lightType: "normal", },
  { id: "grupo04", modulo: "1", idx: "4", descricao: "Cancela Serviço Externo", x: 23, y: 63, width: 2.5, height: 5, circleNumber: 4, lightType: "normal", },
  { id: "grupo05", modulo: "1", idx: "5", descricao: "Cancela Social", lightType: "mixed",  
    normalLights:[{x: 29, y: 48, width: 2.5, height: 5, circleNumber: 5}],
    ledStrips:[
      { x: -1, y: -14, width: 100, height: 130, isLedStrip: true, ledPath: "M 35.47 55.90 L 35.64 47.15", ledColor: "#f4bb00", ledMode: "static", ledStrokeWidth: "0.25"},
    ]

},

  { id: "grupo06", modulo: "1", idx: "6", descricao: "Lobby", x: 0, y: 0, width: 2.5, height: 5, circleNumber: 6, lightType: "normal", multipleInstances:[
    { x: 38, y: 48, width: 2.5, height: 5, circleNumber: 6 },
    { x: 54, y: 47, width: 2.5, height: 5, circleNumber: 6 },
  ]},

  { id: "grupo07", modulo: "1", idx: "7", descricao: "Coworking", x: 33, y: 59, width: 2.5, height: 5, circleNumber: 7, lightType: "normal", },
  { id: "grupo08", modulo: "1", idx: "8", descricao: "Delivery box", x: 29, y: 68, width: 2.5, height: 5, circleNumber: 8, lightType: "normal", },
  { id: "grupo09", modulo: "2", idx: "1", descricao: "Escadaria Frente",lightType: "normal",  multipleInstances:[
    { x: 20, y: 49, width: 2.5, height: 5, circleNumber: 9, },
    { x: 13, y: 48, width: 2.5, height: 5, circleNumber: 9 }
  ]},
  { id: "grupo10", modulo: "2", idx: "2", descricao: "Jardim dos Temperos", x: 14, y: 91, width: 2.5, height: 5, circleNumber: 10, lightType: "normal", },

  { id: "grupo11", modulo: "2", idx: "3", descricao: "Jardim Geral Frente", x: 0, y: 0, width: 2.5, height: 5, circleNumber: 11, lightType: "normal", multipleInstances:[
    { x: 13, y: 71.5, width: 2.5, height: 5, circleNumber: 11 },
    { x: 19, y: 65, width: 2.5, height: 5, circleNumber: 11 },
    { x: 21, y: 40, width: 2.5, height: 5, circleNumber: 11 },
    { x: 13, y: 37, width: 2.5, height: 5, circleNumber: 11 },
    { x: 12, y: 59, width: 2.5, height: 5, circleNumber: 11 },
  ]},

  { id: "grupo12", modulo: "2", idx: "4", descricao: "Vigia", lightType: "normal", multipleInstances:[
    { x: 36, y: 30, width: 2.5, height: 5, circleNumber: 12 },
    { x: 47, y: 35.5, width: 2.5, height: 5, circleNumber: 12 },
    { x: 62, y: 30, width: 2.5, height: 5, circleNumber: 12 },
    { x: 76, y: 83, width: 2.5, height: 5, circleNumber: 12 },
    { x: 60, y: 76, width: 2.5, height: 5, circleNumber: 12 },
    { x: 48.5, y: 84, width: 2.5, height: 5, circleNumber: 12 },
  ]},

  // INTERMEDIARIO CIRCUITOS
  { id: "grupo13", modulo: "2", idx: "5", descricao: "Cancela Summer Square", lightType: "normal", multipleInstances:[
    {x: 35, y: 48, width: 2.5, height: 5, circleNumber: 13},
    {x: 47, y: 42, width: 2.5, height: 5, circleNumber: 13},
    {x: 66, y: 41, width: 2.5, height: 5, circleNumber: 13},
    {x: 67, y: 54, width: 2.5, height: 5, circleNumber: 13},
  ]},

  { id: "grupo14", modulo: "2", idx: "6", descricao: "Floreira", x: 0, y: 0, width: 2.5, height: 5, circleNumber: 14, lightType: "normal", multipleInstances:[
    { x: 33.5, y: 41, width: 2.5, height: 5, circleNumber: 14 },
    { x: 40, y: 36, width: 2.5, height: 5, circleNumber: 14 },

    { x: 48, y: 37, width: 2.5, height: 5, circleNumber: 14 },
    { x: 65, y: 36, width: 2.5, height: 5, circleNumber: 14 },
    { x: 73, y: 36, width: 2.5, height: 5, circleNumber: 14 },
    { x: 70, y: 51, width: 2.5, height: 5, circleNumber: 14 },
  ]},

  { id: "grupo15", modulo: "2", idx: "7", descricao: "Externa", lightType: "normal", multipleInstances:[
    {x: 41, y: 29, width: 2.5, height: 5, circleNumber: 15},
    {x: 48, y: 31, width: 2.5, height: 5, circleNumber: 15},
    {x: 58, y: 33, width: 2.5, height: 5, circleNumber: 15} 
  ]},
  { id: "grupo16", modulo: "2", idx: "8", descricao: "Summer House", x: 82, y: 34, width: 2.5, height: 5, circleNumber: 16, lightType: "normal", },
  { id: "grupo17", modulo: "3", idx: "1", descricao: "Lavabos Casa de Máquinas", x: 77.2, y: 34, width: 2.5, height: 5, circleNumber: 17, lightType: "normal", },
  { id: "grupo18", modulo: "3", idx: "2", descricao: "Sauna", x: 76.75, y: 29, width: 2.5, height: 5, circleNumber: 18, lightType: "normal", },
  { id: "grupo19", modulo: "3", idx: "3", descricao: "Deck Descoberto", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 19, lightType: "normal", },

  { id: "grupo20", modulo: "3", idx: "4", descricao: "Summer House Piscina", x: 0, y: 0, width: 2.5, height: 5, circleNumber: 20, lightType: "normal", multipleInstances:[
    { x: 81, y: 18, width: 2.5, height: 5, circleNumber: 20 },
    { x: 85, y: 22, width: 2.5, height: 5, circleNumber: 20 },
  ]},

  { id: "grupo21", modulo: "3", idx: "5", descricao: "Poll House Piscina", lightType: "mixed", 
    normalLights:[
    { x: 73, y: 17, width: 2.5, height: 5, circleNumber: 21 },
    { x: 58, y: 17, width: 2.5, height: 5, circleNumber: 21 },
    { x: 43, y: 17, width: 2.5, height: 5, circleNumber: 21 },
    { x: 28, y: 17, width: 2.5, height: 5, circleNumber: 21 },
    //{ x: 70, y: 29, width: 2.5, height: 5, circleNumber: 21 },
  ],
 ledStrips:[
      { x: 0.5, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 71 38 L 70 20", ledColor: "#f4bb00", ledMode: "static", ledStrokeWidth: "0.25"},
      { x: 0, y: -7, width: 100, height: 130, isLedStrip: true, ledPath: "M 78.53 27.32 L 77.71 20.87", ledColor: "#f4bb00", ledMode: "static", ledStrokeWidth: "0.25"},
    ]
},

  { id: "grupo22", modulo: "3", idx: "6", descricao: "Piscina Adulto", lightType: "normal", multipleInstances:[
    { x: 54, y: 23, width: 2.5, height: 5, circleNumber: 22},
    { x: 69, y: 22.5, width: 2.5, height: 5, circleNumber: 22},
  ]},

  { id: "grupo23", modulo: "3", idx: "7", descricao: "Floreira Deck Molhada", lightType: "normal",  multipleInstances:[
    { x: 26, y: 23, width: 2.5, height: 5, circleNumber: 23 },
    { x: 32, y: 27, width: 2.5, height: 5, circleNumber: 23 },
    { x: 50, y: 27, width: 2.5, height: 5, circleNumber: 23 },
    { x: 62, y: 27, width: 2.5, height: 5, circleNumber: 23 }
  ]},

  { id: "grupo24", modulo: "3", idx: "8", descricao: "Square Up", x: 83.5, y: 48, width: 2.5, height: 5, circleNumber: 24, lightType: "normal", },
  { id: "grupo25", modulo: "4", idx: "1", descricao: "Beach Tennis", x: 86.5, y: 65, width: 2.5, height: 5, circleNumber: 25, lightType: "normal", },

  { id: "grupo26", modulo: "4", idx: "2", descricao: "Fitness", x: 0, y: 0, width: 2.5, height: 5, circleNumber: 26, lightType: "mixed",
    normalLights:[
      { x: 67.5, y: 78, width: 2.5, height: 5, circleNumber: 26 }
    ],
    ledStrips:[
      { x: 5, y: 0, width: 93, height: 100, isLedStrip: true, ledPath: "M 61 73 L 78 73", ledColor: "#f4bb00", ledMode: "static", ledStrokeWidth: "0.25"},
      { x: 5, y: 0, width: 93, height: 100, isLedStrip: true, ledPath: "M 61 75 L 78 75", ledColor: "#f4bb00", ledMode: "static", ledStrokeWidth: "0.25"},
      { x: 5, y: 0, width: 93, height: 100, isLedStrip: true, ledPath: "M 61 77 L 78 77", ledColor: "#f4bb00", ledMode: "static", ledStrokeWidth: "0.25"},

      { x: 4, y: 0, width: 95, height: 100, isLedStrip: true, ledPath: "M 71 79 L 78 79", ledColor: "#f4bb00", ledMode: "static", ledStrokeWidth: "0.25"},
      { x: 4, y: 0, width: 95, height: 100, isLedStrip: true, ledPath: "M 71 81 L 78 81", ledColor: "#f4bb00", ledMode: "static", ledStrokeWidth: "0.25"},
      { x: 4, y: 0, width: 95, height: 100, isLedStrip: true, ledPath: "M 71 83 L 78 83", ledColor: "#f4bb00", ledMode: "static", ledStrokeWidth: "0.25"},
    ]},

  { id: "grupo27", modulo: "4", idx: "3", descricao: "Summer Kitchen", x: 55.5, y: 80, width: 2.5, height: 5, circleNumber: 27, lightType: "normal", multipleInstances:[
    { x: 46, y: 80, width: 2.5, height: 5, circleNumber: 27 },
  ]},

  { id: "grupo28", modulo: "4", idx: "4", descricao: "Pergolado Summer Kitchen", x: 49, y: 78, width: 2.5, height: 5, circleNumber: 28, lightType: "normal", },

  { id: "grupo29", modulo: "4", idx: "5", descricao: "Jardim Green Square", x: 0, y: 0, width: 2.5, height: 5, circleNumber: 29, lightType: "normal",multipleInstances:[
    { x: 38, y: 80, width: 2.5, height: 5, circleNumber: 29 },
    { x: 56, y: 78, width: 2.5, height: 5, circleNumber: 29 },
  ]},

  { id: "grupo30", modulo: "4", idx: "6", descricao: "Balizadores", lightType: "normal", multipleInstances:[
    { x: 77.5, y: 73, width: 2.5, height: 5, circleNumber: 30 },
    { x: 78.5, y: 78.5, width: 2.5, height: 5, circleNumber: 30 }
  ]},
  { id: "grupo31", modulo: "4", idx: "7", descricao: "Green House", x: 30, y: 76, width: 2.5, height: 5, circleNumber: 31, lightType: "normal", },

  { id: "grupo32", modulo: "4", idx: "8", descricao: "Poste Green Square", lightType: "normal", multipleInstances:[
    { x: 37, y: 72, width: 2.5, height: 5, circleNumber: 32 },
    { x: 43, y: 72, width: 2.5, height: 5, circleNumber: 32 },
    { x: 48, y: 72, width: 2.5, height: 5, circleNumber: 32 },
    { x: 52, y: 72, width: 2.5, height: 5, circleNumber: 32 }
  ]},

  { id: "grupo33", modulo: "5", idx: "1", descricao: "Jardim Green House", lightType: "normal",  multipleInstances:[
    { x: 23.5, y: 75, width: 2.5, height: 5, circleNumber: 33 },
    { x: 30, y: 66, width: 2.5, height: 5, circleNumber: 33 }
  ]},

  { id: "grupo34", modulo: "5", idx: "2", descricao: "Tay Lounge/Copa", lightType: "normal", multipleInstances:[
    { x: 41, y: 62, width: 2.5, height: 5, circleNumber: 34 },
    { x: 36, y: 57, width: 2.5, height: 5, circleNumber: 34 },
    { x: 25, y: 57, width: 2.5, height: 5, circleNumber: 34 },
  ]},
  { id: "grupo35", modulo: "5", idx: "3", descricao: "Praça Coberta", x: 50, y: 57, width: 2.5, height: 5, circleNumber: 35, lightType: "normal", },
  { id: "grupo36", modulo: "5", idx: "4", descricao: "Jardim", x: 48, y: 62, width: 2.5, height: 5, circleNumber: 36, lightType: "normal", },
  { id: "grupo37", modulo: "5", idx: "5", descricao: "Praça Coberta", lightType: "normal", multipleInstances:[
    {x: 58.5, y: 72, width: 2.5, height: 5, circleNumber: 37},
    {x: 69.5, y: 68, width: 2.5, height: 5, circleNumber: 37}
  ]},
  { id: "grupo41", modulo: "6", idx: "1", descricao: "Lavanderia", x: 46, y: 65, width: 2.5, height: 5, circleNumber: 41, lightType: "normal", },
  { id: "grupo42", modulo: "6", idx: "2", descricao: "Tomadas Lavanderia MAQ", x: 48.5, y: 68, width: 2.5, height: 5, circleNumber: 42, lightType: "normal", },
  { id: "grupo43", modulo: "6", idx: "3", descricao: "Hidromassagem", lightType: "normal",  multipleInstances:[
    {x: 38, y: 23, width: 2.5, height: 5, circleNumber: 43},
    {x: 59, y: 22.5, width: 2.5, height: 5, circleNumber: 43}
  ]},
  { id: "grupo44", modulo: "6", idx: "4", descricao: "Bomba Jatos", x: 25, y: 42, width: 2.5, height: 5, circleNumber: 44, lightType: "normal", },
  { id: "grupo45", modulo: "6", idx: "5", descricao: "Acionamento Reserva", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 45, lightType: "normal", },
  { id: "grupo46", modulo: "6", idx: "6", descricao: "Acionamento Reserva", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 46, lightType: "normal", },
  { id: "grupo47", modulo: "6", idx: "7", descricao: "Acionamento Reserva", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 47, lightType: "normal", },
  { id: "grupo48", modulo: "6", idx: "8", descricao: "Acionamento Reserva", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 48, lightType: "normal", },
];

// Função útil para obter informações de ON/OFF para cada circuito
export const getCircuitOnOffValues = (circuitNumber) => {
  const circuitIndex = circuitNumber - 1;
  if (circuitIndex < 0 || circuitIndex >= iluminacaoConfig.length) {
    return null;
  }
  
  const circuit = iluminacaoConfig[circuitIndex];
  return {
    descricao: circuit.descricao,
    onValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "ON" }),
    offValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "OFF" })
  };
};